<template>
  <span
    class="img-wrapper"
    @click="$emit('click', $event)"
    :style="{'background-color': icon.transparent ? 'transparent' : selectedProject.siteTheme.buttonLight.background}"
  ></span>
</template>

<script>
import projectMixin from "./project/project-mixin";
export default {
  props: ["icon"],
  mixins: [projectMixin],
  watch: {
    "icon.svg": function() {
      this.setInnerHtml();
    },
    "icon.transparent": function() {
      this.setInnerHtml();
    }
  },
  methods: {
    setInnerHtml() {
      if (this.icon.svg) {
        const siteTheme = this.selectedProject.siteTheme;
        const svg = this.icon.svg.replace(
          "{fillColor}",
          siteTheme.buttonLight.text
        );
        this.$el.innerHTML = svg;
      } else {
        this.$el.innerHTML = "";
      }
    }
  },
  mounted() {
    this.setInnerHtml();
  }
};
</script>

<style scoped>
.img-wrapper {
  border-radius: 100%;
  display: block;
  padding: 10px;
  height: 50px;
  width: 50px;
}
</style>